function getDomain(url) {
  var domain = '';
  if (url) {
    var match = url.match(/([a-z0-9]+\.)*[a-z0-9]+\.[a-z]+/g);
    if (match && match.length) {
      domain = match[0].replace(/^(www\.)/, '');
    }
  }
  return domain;
}

export default getDomain;
